import { AlertCircle, CheckCircle, Info } from "lucide-react";

const ICONS = {
  error: AlertCircle,
  success: CheckCircle,
  info: Info,
  warning: AlertCircle,
};

export default function AlertBanner({ variant = "info", children, className = "", onAction, actionLabel }) {
  const Icon = ICONS[variant] || Info;
  return (
    <div className={`alert-banner alert-banner--${variant} ${className}`} role="alert">
      <Icon size={18} strokeWidth={1.75} className="alert-banner-icon" />
      <div className="alert-banner-body">{children}</div>
      {onAction ? (
        <button type="button" className="btn btn-sm" onClick={onAction}>
          {actionLabel || "Action"}
        </button>
      ) : null}
    </div>
  );
}
